import produce from 'immer'
import {
  ALERT_RULES_LOAD,
  ALERT_RULES_LOAD_SUCCESS,
  ALERT_RULES_LOAD_FAIL,
  GET_ALERT_USAGE_BY_PROJECT,
  GET_ALERT_USAGE_BY_PROJECT_SUCCESS,
  GET_ALERT_USAGE_BY_PROJECT_FAIL
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {},
  alertUsageByProject: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ALERT_RULES_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case ALERT_RULES_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.alertRules
        return
      }
      case ALERT_RULES_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      case GET_ALERT_USAGE_BY_PROJECT: {
        // Could set loading state here if needed
        return
      }
      case GET_ALERT_USAGE_BY_PROJECT_SUCCESS: {
        draft.alertUsageByProject = action.alertUsageByProject
        return
      }
      case GET_ALERT_USAGE_BY_PROJECT_FAIL: {
        draft.alertUsageByProject = {}
        return
      }
      default:
        return
    }
  })
